import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import '@/style/style.scss';

// import axios from "axios";
import {post,get,put,DELETE} from '../src/axios/axios'
import XLSX from 'xlsx';
//引入video插件
import VideoPlayer from "vue-video-player";
import 'video.js/dist/video-js.css'
//引入 hls
import 'videojs-contrib-hls'
document.title = '成都中医药大学博物馆预约管理系统'
let toGo = true;
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    if (toGo) {
      next();//跳入to login
    } else {
      next({
        path: "/personalAuditing",//跳转路由
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
});


Vue.use(VideoPlayer)

Vue.prototype.$axiosPost =  (url,data) =>post(url,data)
Vue.prototype.$axiosDelete =  (url,data) =>DELETE(url,data)
Vue.prototype.$axiosPut =  (url,data) =>put(url,data)
Vue.prototype.$axiosGet =  (url,data) =>get(url,data)
// Vue.prototype.$axios = axios
Vue.use(ElementUI);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
